<template>
    <SiteFooter :hideNavigation="hideNavigation" :largeLogoContainer="false" :isRatesTable="isRatesTable">
        <template v-slot:powered-by>
            <a href="http://www.monevo.com">
                <img
                    class="footer-logo"
                    v-if="themeSetting('monevo_footer_logo')"
                    :src="asset(`/img/logos/${themeSetting('monevo_footer_logo')}`)"
                    width="75"
                    alt="Monevo"
                />
            </a>
        </template>

        <template v-slot:rates-table-navigation>
            <ul class="d-flex flex-column flex-md-row" v-if="RatesTableMenu">
                <li class="menu-item" v-for="(menuItem, index) in RatesTableMenu" :key="index">
                    <ConditionalLink
                        type="external"
                        link="#cookies"
                        classes="t-small ot-sdk-show-settings"
                        v-if="menuItem.name == 'Cookie Preference' && hasOneTrustCookieToken"
                    >
                        {{ menuItem.name }}
                    </ConditionalLink>

                    <a :href="menuItem.url" target="_blank" :class="classes" v-else>
                        {{ menuItem.name }}
                    </a>
                </li>
            </ul>
        </template>
    </SiteFooter>
</template>

<script>
import { useStore } from 'vuex'
export default {
    props: {
        hideNavigation: Boolean,
        isRatesTable: Boolean,
    },
    setup() {
        const store = useStore()
        return {
            store,
        }
    },
    computed: {
        territory: function () {
            return process.env.TERRITORY
        },
        menu: function () {
            return this.store.state.global.data.menu || {}
        },
        RatesTableMenu: function () {
            return this.menu.ratesTable || false
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/settings/variables';
@import '~scss/mixins/rem';

.logo {
    display: flex;
    justify-content: center;
    margin: 1.5em 1em 0;
    position: relative;
    text-align: left;

    @media all and (min-width: $bp-medium) {
        justify-content: flex-start;
    }

    &__img {
        margin: 0;
        width: 40px;
    }

    &__text {
        margin: -4px 0 0 5px;

        .line1 {
            font-size: 0.875em;
            white-space: nowrap;
            color: white;
        }

        .line2 {
            white-space: nowrap;
            color: white;
        }

        @media screen and (max-width: $bp-medium) {
            margin: 41px 0 0 5px;

            .line1 {
                font-size: 11px;
            }

            .line2 {
                font-size: 13px;
            }
        }
    }
}

.footer-logo {
    max-height: 45px;

    @media screen and (min-width: $bp-medium) {
        margin-top: 0;
    }
}

.footer-logo:nth-of-type(2) {
    margin-top: 15px;

    @media screen and (min-width: $bp-medium) {
        margin-top: 0;
    }

    @media screen and (max-width: $bp-medium) {
        margin-top: 44px;
    }
}

.nav-list__link {
    font-weight: bold;
    margin-bottom: 16px;
    white-space: nowrap;

    @media screen and (min-width: $bp-medium) {
        margin-bottom: 0;
    }
}

.legal-footer {
    background-color: var(--footer-legal-background-color);
    border-radius: 4px;
    color: var(--footer-legal-text-color);
    padding: 30px 32px 40px;
}
</style>
